/* eslint-disable no-useless-escape */
/* eslint-disable  */
/* eslint-disable no-redeclare */
/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
// React Components
import { Button, IconButton, Badge } from "@material-ui/core";
import { Link, useLocation,useNavigate } from "react-router-dom";

import "./Navbar.scss"
/* eslint-disable */
import React, { useContext, useEffect } from "react";
import { useState } from "react";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ReceiptIcon from "@mui/icons-material/Receipt";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import { withTranslation } from "react-i18next";

import noImg from "../assets/images/no-image.svg";
import { makeStyles } from "@material-ui/core/styles";
// reduxNavbar
import { useSelector, useDispatch } from "react-redux";
import FilterListIcon from "@mui/icons-material/FilterList";
import { RootState } from "../../store/reducers";
import { actionCreators } from "../../store";
import { bindActionCreators } from "redux";

// import { get_lang } from "../../../global-functions/apiGlobal";


const Navbar = (props: any) => {
  const {showBackBtn = true, handleGoBack = undefined} = props
  const appDispatch = useDispatch();
  const state = useSelector((state: RootState) => state.appReducer);
  const matches = useMediaQuery("(min-width:600px)");
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    langValueState
  } = bindActionCreators(actionCreators, dispatch);

  const [scroll, setScroll] = useState(false);
  useEffect(() => {
    const scrolling = () => {
      const handleScroll = () => {
        setScroll(window.scrollY > 0);
      };
  
      window.addEventListener("scroll", handleScroll);
  
      // Cleanup function to remove the event listener when the component unmounts
      return () => {
        window.removeEventListener("scroll", handleScroll);
      };
    };
  
    scrolling();
  }, []);


;

  return (
    <div id="Navbar" className={`${state.langValue === "ar" ? " direction-rtl" : "direction-ltr"
}`}>
      <div
      >
       
        <div className={
          // Number(scroll) > 0
          false
          ? `top_nav_bar_scroll` : 
        `top_nav_bar`
      }>
        <div className="row  m-0 searhIcon" style={{ position: "static" }}>
             { <div className="d-flex align-items-center col-2 px-1">
          <a >
          { showBackBtn &&<IconButton
                  // component={Link}
                  // to={`/`}
                  aria-label="back"
                  className={`backBtn ${
                    state.langValue === "ar" ? "backBtnAr" : ""
                  }`}
                  onClick={handleGoBack}    
                              >
                  {state.langValue == "ar" ? (
                    <ArrowForwardIosIcon
                      style={{ padding: 0 }}
                      fontSize="inherit"
                    />
                  ) : (
                    <ArrowBackIosIcon fontSize="inherit" />
                  )}
                </IconButton>}
          </a>
              </div>}

              <div className="col-6 d-flex justify-content-end">
                {state.langValue == "ar" ? (
                  <IconButton
                    className="engBtn"
                    id="headerBtn"
                    onClick={() => langValueState("en")}
                  >
                    <span
                      className={`engBtnSpan ${
                        Number(scroll) > 0 ? `lang-textScroll p-0 ` : `lang-text p-0`
                      }`}
                    >
                      EN
                    </span>
                  </IconButton>
                ) : (
                  <IconButton
                    className="arabicbutton"
                    id="headerBtn"
                    onClick={() => langValueState("ar")}
                  >
                    <span
                      className={`arabicbuttonSpan familyGraphikArabic600 ${
                        Number(scroll) > 0 ? `lang-textScroll p-0 ` : `lang-text p-0`
                      }`}
                    >
                      عربي
                    </span>
                  </IconButton>
                )}

      
              </div>
            </div>
        </div>
      </div>

    </div>
  );
};

export default withTranslation()(Navbar);
